import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

export const syncDepartmentSourceFields = async <
  T extends Record<string, unknown>,
>({
  data,
  query,
  domain,
  headers,
}: FetchRequestArgs & {
  data: {
    departmentId: string;
    reason: 'rebuild';
  };
}): Promise<ReturnType<typeof fetchRequest>> => {
  return fetchRequest<T>({
    data,
    domain,
    endpoint: `/v1/audiences/syncs`,
    headers,
    method: HTTPMethod.POST,
    query,
  });
};
